module.exports = __webpack_public_path__ + "templates.dialog.facebook-subscription-06c8d076.html";